import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import {
  Command,
  Exception,
  Job,
  JobCancelResponse,
  JobRequest,
  JobResubmitResponse,
  Status,
} from '../model/job.model'

@Injectable({
  providedIn: 'root',
})
export abstract class JobsService {
  abstract getJobs(request: JobRequest): Observable<Job[]>

  abstract getCommands(jobId: number): Observable<Command[]>

  abstract getCommandLogs(jobId: number): Observable<Command[]>

  abstract getException(jobId: number): Observable<Exception>

  abstract getStatus(jobId: number): Observable<Status[]>

  abstract cancelJobs(jobIds: number[]): Observable<JobCancelResponse>

  abstract resubmitJobs(jobIds: number[]): Observable<JobResubmitResponse>
}
